import Endpoint from "../../services/api/endpoint";
import { IMunicipality } from "../../utils/types/models";
import { createSystemEntityReducer } from "./systemEntityReducer";

export default createSystemEntityReducer<IMunicipality>(Endpoint.Municipalities);